var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "p-t-xs-20 p-b-xs-20" },
    [
      _c("div", { staticClass: "container-fluid" }, [
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-lg-12" }, [
            _c(
              "div",
              { staticClass: "m-b-xs-20" },
              [
                _c(
                  "ak-button",
                  { attrs: { size: "small" }, on: { click: _vm.backToGrid } },
                  [
                    _c("i", { staticClass: "ak-icon ak-button__icon" }, [
                      _vm._v("arrow_left"),
                    ]),
                    _vm._v(
                      "\n                        " +
                        _vm._s(_vm.$t("Ga terug")) +
                        "\n                    "
                    ),
                  ]
                ),
              ],
              1
            ),
          ]),
        ]),
        _vm._v(" "),
        _vm.doubles
          ? _c(
              "div",
              { staticClass: "col-lg-12" },
              _vm._l(_vm.doubles, function (level, index) {
                return _c(
                  "div",
                  {
                    key: index,
                    staticClass: "ak-panel ak-panel--no-padding m-b-xs-20",
                  },
                  [
                    _c(
                      "div",
                      {
                        class:
                          "ak-panel__header ak-panel__header--small ak-panel__header--" +
                          _vm.getLevelAlert(index),
                      },
                      [
                        _c("div", {
                          staticClass: "ak-panel__title",
                          domProps: {
                            innerHTML: _vm._s(_vm.getLevelTitle(index)),
                          },
                        }),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass:
                          "ak-panel__body ak-panel__body--small reading",
                      },
                      [
                        _c(
                          "table",
                          { staticClass: "ak-table ak-panel__table" },
                          [
                            _c("thead", [
                              _c("tr", { staticClass: "ak-table-row" }, [
                                _c("th", { staticClass: "ak-table-head" }, [
                                  _vm._v(
                                    "\n                                    " +
                                      _vm._s(_vm.$t("E-mailadres")) +
                                      "\n                                "
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("th", { staticClass: "ak-table-head" }, [
                                  _vm._v(
                                    "\n                                    " +
                                      _vm._s(_vm.$t("Achternaam")) +
                                      "\n                                "
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("th", { staticClass: "ak-table-head" }, [
                                  _vm._v(
                                    "\n                                    " +
                                      _vm._s(_vm.$t("Voornaam")) +
                                      "\n                                "
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("th", { staticClass: "ak-table-head" }, [
                                  _vm._v(
                                    "\n                                    " +
                                      _vm._s(_vm.$t("Geboortedatum")) +
                                      "\n                                "
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("th", { staticClass: "ak-table-head" }, [
                                  _vm._v(
                                    "\n                                    " +
                                      _vm._s(_vm.$t("Adres")) +
                                      "\n                                "
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("th", { staticClass: "ak-table-head" }, [
                                  _vm._v(
                                    "\n                                    " +
                                      _vm._s(_vm.$t("Organisatie")) +
                                      "\n                                "
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("th", { staticClass: "ak-table-head" }, [
                                  _vm._v(
                                    "\n                                    " +
                                      _vm._s(_vm.$t("Laatste bezoek")) +
                                      "\n                                "
                                  ),
                                ]),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c(
                              "tbody",
                              { staticClass: "ak-table-body" },
                              [
                                _vm._l(level, function (entry, index2) {
                                  return [
                                    _vm._l(entry, function (double, index3) {
                                      return [
                                        _c(
                                          "tr",
                                          { staticClass: "ak-table-row" },
                                          [
                                            _c(
                                              "td",
                                              {
                                                staticClass: "ak-table-column",
                                                style:
                                                  index3 === 1
                                                    ? "border-bottom:2px solid #aaa;"
                                                    : "",
                                              },
                                              [
                                                _c(
                                                  "a",
                                                  {
                                                    attrs: { href: "#" },
                                                    on: {
                                                      click: function ($event) {
                                                        $event.preventDefault()
                                                        return _vm.openUserForm(
                                                          double.hashId
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                                                " +
                                                        _vm._s(double.email) +
                                                        "\n                                            "
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "td",
                                              {
                                                staticClass: "ak-table-column",
                                                style:
                                                  index3 === 1
                                                    ? "border-bottom:2px solid #aaa;"
                                                    : "",
                                              },
                                              [
                                                _vm._v(
                                                  "\n                                            " +
                                                    _vm._s(double.surname) +
                                                    "\n                                        "
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "td",
                                              {
                                                staticClass: "ak-table-column",
                                                style:
                                                  index3 === 1
                                                    ? "border-bottom:2px solid #aaa;"
                                                    : "",
                                              },
                                              [
                                                _vm._v(
                                                  "\n                                            " +
                                                    _vm._s(double.firstName) +
                                                    "\n                                        "
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "td",
                                              {
                                                staticClass: "ak-table-column",
                                                style:
                                                  index3 === 1
                                                    ? "border-bottom:2px solid #aaa;"
                                                    : "",
                                              },
                                              [
                                                _vm._v(
                                                  "\n                                            " +
                                                    _vm._s(
                                                      double.birthDateForDisplay
                                                    ) +
                                                    "\n                                        "
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "td",
                                              {
                                                staticClass: "ak-table-column",
                                                style:
                                                  index3 === 1
                                                    ? "border-bottom:2px solid #aaa;"
                                                    : "",
                                              },
                                              [
                                                _vm._v(
                                                  "\n                                            " +
                                                    _vm._s(double.fullAddress) +
                                                    "\n                                        "
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "td",
                                              {
                                                staticClass: "ak-table-column",
                                                style:
                                                  index3 === 1
                                                    ? "border-bottom:2px solid #aaa;"
                                                    : "",
                                              },
                                              [
                                                _vm._v(
                                                  "\n                                            " +
                                                    _vm._s(
                                                      double.organisationTitle
                                                    ) +
                                                    "\n                                        "
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "td",
                                              {
                                                staticClass: "ak-table-column",
                                                style:
                                                  index3 === 1
                                                    ? "border-bottom:2px solid #aaa;"
                                                    : "",
                                              },
                                              [
                                                _vm._v(
                                                  "\n                                            " +
                                                    _vm._s(
                                                      double.dateLastVisitForDisplay
                                                    ) +
                                                    "\n                                        "
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                      ]
                                    }),
                                  ]
                                }),
                              ],
                              2
                            ),
                          ]
                        ),
                      ]
                    ),
                  ]
                )
              }),
              0
            )
          : _vm._e(),
      ]),
      _vm._v(" "),
      _c("router-view", { attrs: { name: "childview" } }),
      _vm._v(" "),
      _c("ak-loader", { attrs: { size: "large", loading: _vm.loading } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }